export default __webpack_public_path__ + "static/media/kellton-logo.fa82acdc.svg";